module.exports = __webpack_public_path__ + "img/jesa.086e7b0c.png";